import pyc_1 from "./../../assets/images/proyectos/pyc/pyc_1.jpg";
import pyc_2 from "./../../assets/images/proyectos/pyc/pyc_2.jpg";
import pyc_3 from "./../../assets/images/proyectos/pyc/pyc_3.jpg";
import pyc_4 from "./../../assets/images/proyectos/pyc/pyc_4.jpg";
import pyc_5 from "./../../assets/images/proyectos/pyc/pyc_5.jpg";
import pyc_6 from "./../../assets/images/proyectos/pyc/pyc_6.jpg";
import pyc_7 from "./../../assets/images/proyectos/pyc/pyc_7.jpg";
import pyc_8 from "./../../assets/images/proyectos/pyc/pyc_8.jpg";
import pyc_9 from "./../../assets/images/proyectos/pyc/pyc_9.jpg";
import pyc_10 from "./../../assets/images/proyectos/pyc/pyc_10.jpg";
import pyc_11 from "./../../assets/images/proyectos/pyc/pyc_11.jpg";
import pyc_12 from "./../../assets/images/proyectos/pyc/pyc_12.jpg";
import pyc_13 from "./../../assets/images/proyectos/pyc/pyc_13.jpg";
import pyc_14 from "./../../assets/images/proyectos/pyc/pyc_14.jpg";
import pyc_15 from "./../../assets/images/proyectos/pyc/pyc_15.jpg";
import pyc_16 from "./../../assets/images/proyectos/pyc/pyc_16.jpg";
import pyc_17 from "./../../assets/images/proyectos/pyc/pyc_17.jpg";
import pyc_18 from "./../../assets/images/proyectos/pyc/pyc_18.jpg";
import pyc_19 from "./../../assets/images/proyectos/pyc/pyc_19.jpg";
import pyc_20 from "./../../assets/images/proyectos/pyc/pyc_20.jpg";
import pyc_21 from "./../../assets/images/proyectos/pyc/pyc_21.jpg";
import pyc_22 from "./../../assets/images/proyectos/pyc/pyc_22.jpg";
import pyc_23 from "./../../assets/images/proyectos/pyc/pyc_23.jpg";
import pyc_24 from "./../../assets/images/proyectos/pyc/pyc_24.jpg";
import pyc_25 from "./../../assets/images/proyectos/pyc/pyc_25.jpg";
import pyc_26 from "./../../assets/images/proyectos/pyc/pyc_26.jpg";
import pyc_27 from "./../../assets/images/proyectos/pyc/pyc_27.jpg";
import pyc_28 from "./../../assets/images/proyectos/pyc/pyc_28.jpg";
import pyc_29 from "./../../assets/images/proyectos/pyc/pyc_29.jpg";
import pyc_30 from "./../../assets/images/proyectos/pyc/pyc_30.jpg";
import pyc_31 from "./../../assets/images/proyectos/pyc/pyc_31.jpg";
import pyc_32 from "./../../assets/images/proyectos/pyc/pyc_32.jpg";
import pyc_33 from "./../../assets/images/proyectos/pyc/pyc_33.jpg";
import pyc_34 from "./../../assets/images/proyectos/pyc/pyc_34.jpg";
import pyc_35 from "./../../assets/images/proyectos/pyc/pyc_35.jpg";
import pyc_36 from "./../../assets/images/proyectos/pyc/pyc_36.jpg";
import pyc_37 from "./../../assets/images/proyectos/pyc/pyc_37.jpg";
import pyc_38 from "./../../assets/images/proyectos/pyc/pyc_38.jpg";
import pyc_39 from "./../../assets/images/proyectos/pyc/pyc_39.jpg";
import pyc_40 from "./../../assets/images/proyectos/pyc/pyc_40.jpg";
import pyc_41 from "./../../assets/images/proyectos/pyc/pyc_41.jpg";
import pyc_42 from "./../../assets/images/proyectos/pyc/pyc_42.jpg";
import pyc_43 from "./../../assets/images/proyectos/pyc/pyc_43.jpg";
import pyc_44 from "./../../assets/images/proyectos/pyc/pyc_44.jpg";
import pyc_45 from "./../../assets/images/proyectos/pyc/pyc_45.jpg";
import pyc_46 from "./../../assets/images/proyectos/pyc/pyc_46.jpg";
import pyc_47 from "./../../assets/images/proyectos/pyc/pyc_47.jpg";
import pyc_48 from "./../../assets/images/proyectos/pyc/pyc_48.jpg";
import pyc_49 from "./../../assets/images/proyectos/pyc/pyc_49.jpg";
import pyc_50 from "./../../assets/images/proyectos/pyc/pyc_50.jpg";
import pyc_51 from "./../../assets/images/proyectos/pyc/pyc_51.jpg";
import pyc_52 from "./../../assets/images/proyectos/pyc/pyc_52.jpg";
import pyc_53 from "./../../assets/images/proyectos/pyc/pyc_53.jpg";
import pyc_54 from "./../../assets/images/proyectos/pyc/pyc_54.jpg";
import pyc_55 from "./../../assets/images/proyectos/pyc/pyc_55.jpg";
import pyc_56 from "./../../assets/images/proyectos/pyc/pyc_56.jpg";
import pyc_57 from "./../../assets/images/proyectos/pyc/pyc_57.jpg";
import pyc_58 from "./../../assets/images/proyectos/pyc/pyc_58.jpg";
import pyc_59 from "./../../assets/images/proyectos/pyc/pyc_59.jpg";
import pyc_60 from "./../../assets/images/proyectos/pyc/pyc_60.jpg";
import pyc_61 from "./../../assets/images/proyectos/pyc/pyc_61.jpg";
import pyc_62 from "./../../assets/images/proyectos/pyc/pyc_62.jpg";
import pyc_63 from "./../../assets/images/proyectos/pyc/pyc_63.jpg";

// eslint-disable-next-line import/no-anonymous-default-export
export default [
    {
        name: 'Pedro Juan y Diego',
        image: pyc_59,
        description: [
            'Hicimos toda la oferta de sándwiches para Pedro Juan y Diego, la cadena de comida rápida. Un par de días intensos para respetar al máximo la cantidad exacta de ingredientes y sacarles el máximo partido.',
            'Todo natural y fresco. Nada de “truquitos”.'
        ],
        children: [
            {
                name: pyc_59
            },
            {
                name: pyc_60
            },
            {
                name: pyc_61
            },
            {
                name: pyc_62
            },
        ]
    }, {
        name: 'Cafeteria',
        image: pyc_4,
        description: [
            'Una serie de fotos para decorar un restaurante – cafetería.',
            'Nuevamente, sin guión, solo lo que se nos ocurriera hacer e inventar imágenes bonitas.'
        ],
        children: [
            {
                name: pyc_4
            },
            {
                name: pyc_5
            },
            {
                name: pyc_6
            },
        ]
    }, {
        name: 'Aceite de Oliva Soho',
        image: pyc_43,
        description: [
            'Imágenes de marca para una Empresa de Aceite de Oliva. Es tan raro tener libertad de inventar cosas a mi propio parecer.',
            'No solo fue entretenido hacer los famosos Smorrebrod Daneses, sino que nos comimos todo después.'
        ],
        children: [
            {
                name: pyc_43
            },
            {
                name: pyc_50
            },
            {
                name: pyc_19
            },
            {
                name: pyc_14
            },
            {
                name: pyc_1
            },
            {
                name: pyc_58
            },
        ]
    }, {
        name: 'Esso On the Run',
        image: pyc_38,
        description: [
            'Estas fotos tal vez es raro ponerlas en una sección de bodegones y comidas, pero fue una campaña de imagen de “Estilo de Vida” para una tienda de conveniencia de Esso.',
            'Me entretiene combinar estilos y estas fueron hechas en la misma tienda, con productos reales y tratando que sean muy naturales.'
        ],
        children: [
            {
                name: pyc_38
            },
            {
                name: pyc_39
            },
            {
                name: pyc_40
            },
            {
                name: pyc_41
            },
            {
                name: pyc_42
            },
        ]
    }, {
        name: 'Paula Cocina',
        image: pyc_45,
        description: [
            'Recetarios de la Revista Paula. Una mezcla de trabajos con luz natural y también en estudio. Según donde encontrábamos ambientes cerca de cocinas aptas. También filmamos unos videos de recetas, y como eso es lento, siempre estaba el problema que se nos oscurecía y cambiaba la luz.',
            'Así que filmando muy rapidito para alcanzar.'
        ],
        children: [
            {
                name: pyc_45
            },
            {
                name: pyc_46
            },
            {
                name: pyc_47
            },
            {
                name: pyc_53
            },
        ]
    }, {
        name: 'Verduras',
        image: pyc_13,
        description: [
            'Para darle Glamour a la sección verduras de una cadena de Supermercados. Parte de las fotos realizadas. Me encanta trabajar con una sola luz, tal como aprendí de mi Maestro Arthur Beck.'
        ],
        children: [
            {
                name: pyc_3
            },
            {
                name: pyc_13
            },
            {
                name: pyc_15
            },
            {
                name: pyc_16
            },
            {
                name: pyc_17
            },
        ]
    }, {
        name: 'Test de luces',
        image: pyc_18,
        description: [
            'Estaba probando una nueva caja de luz, fabricada en casa cuando hice la foto de los Maníes. Al salir del estudio, pasaba una ambientadora de otra producción en el estudio de al lado con dos flores que ya habían usado y las iban a botar. Se las robé y en don minutos hicimos la flor. Un solo disparo bastó.'
        ],
        children: [
            {
                name: pyc_18
            },
            {
                name: pyc_21
            },
        ]
    }, {
        name: 'Quesos',
        image: pyc_23,
        description: [
            'Las variedades de productos de una Empresa lechera. Me encanta trabajar con una sola luz. Como me hace falta la cámara de placa y la película de 4 x 5 pulgadas. Todo tenía otro saborcito.'
        ],
        children: [
            {
                name: pyc_23
            },
            {
                name: pyc_24
            },
            {
                name: pyc_25
            },
            {
                name: pyc_27
            },
        ]

    }, {
        name: 'Mercedes',
        image: pyc_29,
        description: [
            'Una amiga en Paris hacía estas cosas a mano. Se las pedí prestadas y le regalé las fotos. Ambos estábamos muy felices. Su taller-casa era un precioso desorden lleno de materiales y “cositas” Lamento nunca haberla fotografiado en su casa.'
        ],
        children: [
            {
                name: pyc_29
            },
            {
                name: pyc_30
            },
            {
                name: pyc_31
            },
        ]
    }, {
        name: 'Panaderia',
        image: pyc_44,
        description: [
            'Parte del trabajo para una panadería. Solo crear sensaciones ricas. Esta vez, usando luz continua tungsteno, y el estilismo de Javiera Zurita'
        ],
        children: [
            {
                name: pyc_44
            },
            {
                name: pyc_51
            },
        ]
    }, {
        name: 'Awasi Patagonia',
        image: pyc_7,
        description: [
            'Hotel Awasi Patagonia. Tratando de integrar la magnífica oferta culinaria del Hotel con los maravillosos paisajes de Patagonia. En la sección retratos pueden ver al personal del hotel. Entretenido y agotador hacer: Decoración, Comida, retratos y paisajes en pocos días de viaje. (Además de tener que ir fuera de temporada, con frio y pocas horas de luz.)'
        ],
        children: [
            {
                name: pyc_7
            },
            {
                name: pyc_8
            },
        ]
    }, {
        name: 'Blanco en blanco',
        image: pyc_9,
        description: [
            'Cremas y postres para una Empresa lechera. El clásico fondo blanco. Branco con blanco contra blanco, clásico desafío fotográfico, aquí con unos tonos de color adicional.'
        ],
        children: [
            {
                name: pyc_9
            },
            {
                name: pyc_11
            },
            {
                name: pyc_12
            },
        ]
    }, {
        name: 'Tasty',
        image: pyc_10,
        description: [
            'Imagen para un Restaurante de algo tan simple, rico y bonito.'
        ],
        children: [
            {
                name: pyc_10
            },
        ]
    }, {
        name: 'Green',
        image: pyc_20,
        description: [
            'Simple y natural. Frutas y verduras una fuente inagotable de belleza.'
        ],
        children: [
            {
                name: pyc_20
            },
            {
                name: pyc_22
            },
        ]
    }, {
        name: 'Cosmetics',
        image: pyc_34,
        description: [
            'Cosméticos. Me gustan los desórdenes en las composiciones.'
        ],
        children: [
            {
                name: pyc_34
            },
            {
                name: pyc_26
            },
        ]
    }, {
        name: 'Shu Uemura',
        image: pyc_35,
        description: [
            'Pasa Annayake unas pequeñas fotos para catálogos.'
        ],
        children: [
            {
                name: pyc_35
            },
            {
                name: pyc_36
            },
        ]
    }, {
        name: 'Limelight',
        image: pyc_28,
        description: [
            'Moda teatral. Un experimento con luces como de escenario.'
        ],
        children: [
            {
                name: pyc_28
            },
        ]
    }, {
        name: 'Coaniquem',
        image: pyc_32,
        description: [
            'Campaña para Coaniquem, y la recolección de vidrios como ayuda para el financiamiento de los Niños quemados. El concepto fue de Jorge Leiva, pero el no pudo ir a la foto. Así que sin dirección de Arte, hice lo que mas me gustó y con esta foto me gané un premio a la mejor foto de producto  en Publicidad de El Mercurio, en el Festival de Publicidad.'
        ],
        children: [
            {
                name: pyc_32
            },
        ]
    }, {
        name: 'Tie',
        image: pyc_33,
        description: [
            'Una pequeña foto para una sastrería en Santiago. Nuevamente, una sola luz y sombritas.'
        ],
        children: [
            {
                name: pyc_33
            },
        ]
    }, {
        name: 'Connected',
        image: pyc_37,
        description: [
            'Fuimos a fotografiar un nuevo Data Center para demostrar la alta tecnología. El problema fue que… no había nada instalado en mas de dos mil metros cuadrados. Solo en un rinconcito encontramos este switch y con algunas gelatinas de colores pudimos ilustrar el concepto de tecnología, a pesar de estar en una gran caverna vacía.'
        ],
        children: [
            {
                name: pyc_37
            },
        ]
    }, {
        name: 'Aceite Huasco',
        image: pyc_48,
        description: [
            'Dos preparaciones distintas para dos segmentos de la marca Huasco de Aceite de Oliva.  Inventando sol en un día nublado de invierno. Siempre es así.'
        ],
        children: [
            {
                name: pyc_48
            },
            {
                name: pyc_49
            },
        ]
    }, {
        name: 'Brasas',
        image: pyc_54,
        description: [
            'Realizamos el menú completo para Fuente Nicanor en dos días intensos de trabajo. Nuevamente respetando exactamente las especificaciones del Cliente en cuanto a gramajes, cantidades y preparación.'
        ],
        children: [
            {
                name: pyc_54
            },
            {
                name: pyc_55
            },
            {
                name: pyc_56
            },
            {
                name: pyc_57
            },
        ]
    }, {
        name: 'Lota',
        image: pyc_52,
        description: [
            'Nada mas rico que los pollos a las brazas, claro que gráficamente las brazas son poco atractivas sin unas llamas. Y las brazas son…. Blancas !!!  Hay que buscar la manera que salga el fuego de ellas.'
        ],
        children: [
            {
                name: pyc_52
            },
        ]
    }, {
        name: 'Proyecto 24',
        image: pyc_63,
        description: [
            'Reminiscencia de las minas de Carbón para este Gran vino de Cousiño que lleva el nombre de la legendaria Mina de LOTA..'
        ],
        children: [
            {
                name: pyc_63
            },
        ]
    }

]